@if (!loading && sharedService.urlParams) {
  @if (!customerGuidMissing) {
    <bi-skip-link skipToId="main-content" [label]="'accessibility.GoMainContent' | translate" (onClick)="onSkipToMainContentClicked()" />
    <div [class.blur]="showDisclaimer()">
      <div class="subscription-panel">
        <div class="p-panel p-component">
          <div class="p-panel-header w-12 block">
            <header id="header-container">
              <h1 class="header m-0">{{ title() }}</h1>
              <button
                *ngIf="!sharedService.urlParams.hideBackBtn"
                pButton
                id="reset-button"
                class="p-button-text p-button-icon p-button-rounded pt-0"
                [attr.aria-label]="'shared.Reset' | translate"
                [title]="'shared.Reset' | translate"
                icon="fa-solid fa-redo"
                (click)="onReset()"
              ></button>
            </header>
          </div>
          <main>
            <!-- Container with the 3 steps switching with a slide effect -->
            <div class="p-panel-content">
              <div
                class="slide-container"
                [ngClass]="{
                  'slide-2': currentStep() === 2,
                  'slide-3': currentStep() === 3
                }"
              >
                <div class="slideable-content flex" id="main-content">
                  <div class="push-up-container" [class.push-up]="showEnterPinArea">
                    <!-- STEP 1 - CONTACT DETAILS -->
                    <div class="contact-info-container">
                      <p class="sub-header mb-3 font-normal enter-contact-info-text">
                        {{ subHeaderTranslationKey() | translate }}
                      </p>
                      <!-- Subscriber details -->
                      <form [formGroup]="mobileEmailForm" class="grid bi-p-fluid justify-content-center" *ngIf="mobileEmailForm">
                        <!-- mobile -->
                        <div class="col-12">
                          <bi-phone-input
                            data-uitest="mobile"
                            id="mobile"
                            #phoneInput
                            [onlyMainCountries]="true"
                            [countryId]="sharedService.countryId"
                            formControlName="mobile"
                            [focusable]="currentStep() === 1"
                            [canSelectCountryCode]="true"
                            [attr.aria-invalid]="mobileCtrl.invalid"
                          />
                          <div role="alert">
                            <p class="field-error mb-2" *ngIf="mobileCtrl.errors?.atLeast1Required && mobileCtrl.dirty">
                              {{ atLeast1RequiredMessage | translate }}
                            </p>
                          </div>
                        </div>
                        <!-- landline -->
                        <div class="col-12" *ngIf="sharedService.urlParams.showLandline">
                          <bi-phone-input
                            id="subscribeUnsubscribeIframeLandline"
                            data-uitest="landline"
                            [countryId]="sharedService.countryId"
                            #phoneInputVoice
                            [onlyMainCountries]="true"
                            [label]="'shared.CountryCodeAndLandline' | translate"
                            [isLandLine]="true"
                            [focusable]="currentStep() === 1"
                            [canSelectCountryCode]="true"
                            formControlName="landline"
                            [attr.aria-invalid]="landlineCtrl.invalid"
                          />
                          <div role="alert">
                            <p class="field-error mb-2" *ngIf="landlineCtrl.errors?.atLeast1Required && landlineCtrl.dirty" translate>
                              {{ atLeast1RequiredMessage | translate }}
                            </p>
                          </div>
                        </div>
                        <!-- EMAIL -->
                        <div class="col-12" *ngIf="!sharedService.urlParams.hideEmailInput">
                          <label class="FieldLabel" for="email-field" translate>shared.Email</label>
                          <input
                            type="email"
                            id="email-field"
                            data-uitest="email"
                            autocomplete="email"
                            pInputText
                            [tabindex]="currentStep() === 1 ? 0 : -1"
                            formControlName="email"
                            [placeholder]="'shared.EnterEmail' | translate"
                            [attr.aria-invalid]="emailCtrl.invalid"
                            [attr.aria-label]="'shared.Email' | translate"
                            [attr.aria.hidden]="currentStep() === 1 ? 0 : -1"
                            [title]="'shared.Email' | translate"
                            maxlength="100"
                          />
                          <div role="alert" aria-atomic="true">
                            @if (emailCtrl.invalid && emailCtrl.dirty) {
                              <p class="field-error mb-2" *ngIf="emailCtrl.errors.email" translate>errorMessages.emailInvalid</p>
                              <p class="field-error mb-2" *ngIf="emailCtrl.errors.atLeast1Required">
                                {{ atLeast1RequiredMessage | translate }}
                              </p>
                            }
                          </div>
                        </div>
                        <!-- NAME -->
                        <div class="col-12">
                          <label class="FieldLabel" for="name" translate>shared.Name</label>
                          <input
                            id="name"
                            data-uitest="name"
                            autocomplete="name"
                            pInputText
                            [attr.aria-label]="'shared.Name' | translate"
                            title="{{ 'shared.Name' | translate }}"
                            [tabindex]="currentStep() === 1 ? 0 : -1"
                            [attr.aria.hidden]="currentStep() === 1 ? 0 : -1"
                            formControlName="name"
                            [placeholder]="'shared.EnterName' | translate"
                          />
                        </div>
                        <!-- CAPTCHA (using aria-live for screen readers) -->
                        <div [class.col-12]="showCaptcha" aria-live="assertive">
                          <div *ngIf="showCaptcha" @fadeIn>
                            <p class="cdk-visually-hidden" translate>accessibility.SecurityControl</p>
                            <ngx-recaptcha2 #recaptcha [siteKey]="googleCaptchaConfig.siteKey" [hl]="googleCaptchaConfig.language" formControlName="recaptcha" (success)="onCaptchaSuccess($event)" />
                          </div>
                        </div>
                        <button
                          data-uitest="send-pincode"
                          pButton
                          type="submit"
                          class="send-pin-button mt-4 mb-1"
                          [tabindex]="currentStep() === 1 ? 0 : -1"
                          [disabled]="mobileEmailForm.invalid || mobileEmailForm.pristine"
                          [attr.aria-label]="(sharedService.urlParams.disableAuth ? 'OK' : 'iFrame.Subscription.SendPinCode') | translate"
                          [label]="(sharedService.urlParams.disableAuth ? 'OK' : 'iFrame.Subscription.SendPinCode') | translate"
                          (click)="onOkOrSendCodeClicked()"
                        ></button>
                      </form>
                      <bi-spinner *ngIf="requestingPinCode" [centerInParent]="true" [onTopOfContainer]="true" [hasBackground]="true" />
                    </div>
                    <!-- PIN CODE AREA -->
                    <div class="enter-pin-area" *ngIf="showEnterPinArea && sharedService.urlParams && !sharedService.urlParams.disableAuth">
                      <p class="mb-2" translate>
                        {{ sharedService.urlParams.hideEmailInput ? "iFrame.Subscription.PinSentEnterBelowNoEmail" : "iFrame.Subscription.PinSentEnterBelow" }}
                      </p>
                      <input
                        type="text"
                        #pinInput
                        class="w-6 md:w-4 lg:w-2 xl:w-1"
                        maxlength="4"
                        pInputText
                        [tabindex]="currentStep() === 1 ? 0 : -1"
                        [attr.aria-invalid]="pinCodeCtrl.invalid && pinCodeCtrl.dirty"
                        [placeholder]="'shared.EnterPinCode' | translate"
                        [attr.aria-label]="'shared.PinCode' | translate"
                        [formControl]="pinCodeCtrl"
                        (keyup.enter)="onVerifyPinCode()"
                      />
                      <button
                        pButton
                        type="submit"
                        [tabindex]="currentStep() === 1 ? 0 : -1"
                        style="margin: 0 0.2em 0 0.5em"
                        label="OK"
                        aria-label="OK"
                        (click)="onVerifyPinCode()"
                        [disabled]="pinCodeCtrl.invalid"
                      ></button>
                      <button
                        pButton
                        class="p-button-danger danger-wcag"
                        [tabindex]="currentStep() === 1 ? 0 : -1"
                        [attr.aria-label]="'shared.Cancel' | translate"
                        [label]="'shared.Cancel' | translate"
                        (click)="toggleEnterPinAreaVisibility()"
                      ></button>
                      <bi-spinner spinnerSize="small" *ngIf="verifyingPinCode" />
                      <!-- PIN verification status -->
                      <div role="alert">
                        <p *ngIf="!verifyingPinCode && pinVerified" class="font-bold {{ pinValid ? 'text-green' : 'text-red' }}" translate>
                          {{ pinValid ? "shared.Verified" : "shared.InvalidPin" }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <subscription-overview
                      *ngIf="currentStep() === 2"
                      id="subscription-overview"
                      [mobileEmailName]="mobileEmailForm.value"
                      [(showSubscribeConfirmedText)]="showSubscribeConfirmedText"
                      (onSubscribe)="onSubscribeClicked($event)"
                      (onUnsubscribe)="onUnsubscribe($event)"
                      (OnReset)="onReset()"
                    />
                  </div>
                  <create-address-subscription *ngIf="currentStep() === 3 && !subscribeBySupplyNumber" (onBack)="backToOverview()" (onCreateSubscription)="createAddressSubscription($event)" />
                  <create-supply-number-subscription
                    *ngIf="currentStep() === 3 && subscribeBySupplyNumber && (moduleConfig$ | async).canSubscribeViaSupplyNumber"
                    (onBack)="backToOverview()"
                    (onCreateSubscription)="createSupplyNumberSubscription($event)"
                  />
                </div>
                <button
                  *ngIf="moduleConfig$ | async as moduleConfig"
                  pButton
                  id="show-disclaimer-text-button"
                  class="p-button-link pl-0 my-2"
                  tabindex="0"
                  style="max-width: 100%"
                  [attr.aria-label]="moduleConfig.showDisclaimerText"
                  [label]="moduleConfig.showDisclaimerText"
                  (click)="onShowDisclaimerChanged(true)"
                ></button>
              </div>
            </div>
          </main>
          <bi-spinner [hasBackground]="true" [centerInParent]="true" [onTopOfContainer]="true" *ngIf="loading" />
        </div>
      </div>
    </div>

    <!-- DISCLAIMER -->
    <p-card class="disclaimer-card" [@fadeInOut] *ngIf="showDisclaimer() && moduleConfig$ | async as moduleConfigModel" [cdkTrapFocus]="showDisclaimer()">
      <button
        pButton
        class="close-icon-button p-button-text p-button-icon p-button-rounded"
        icon="fa-solid fa-times fa-2x"
        tabindex="0"
        [attr.aria-label]="'shared.Close' | translate"
        (click)="onShowDisclaimerChanged(false)"
      ></button>

      <p [innerHTML]="moduleConfigModel.disclaimer"></p>

      <div class="text-center close-button">
        <button pButton id="show-disclaimer-text" tabindex="0" [attr.aria-label]="'shared.Close' | translate" [label]="'shared.Close' | translate" (click)="onShowDisclaimerChanged(false)"></button>
      </div>
    </p-card>
  }

  <!-- Message to display if there's no customer public ID Guid in URL params -->
  <p-card *ngIf="customerGuidMissing">
    <div class="text-center" role="alert" aria-atomic="true" translate>
      <i class="fas fa-exclamation-triangle text-red"></i>
      shared.CustomerGuidMissing
      <i class="fas fa-exclamation-triangle text-red"></i>
    </div>
  </p-card>
} @else {
  <bi-spinner spinnerSize="large" [onTopOfContainer]="true" [centerInParent]="true" />
}

<bi-confirm-dialog />
